export default __webpack_public_path__ + "static/media/banner5.fdf8d9e7.jpg";